import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

const HeroSectionWebinarBan = () => {
  const sliderData = [
    {
      id: 1,
      title: "",
      img: "assets/images/event-banner/James-webinar-1.png",
      description: "",
      img2: "assets/images/webinars/fca-supervision-2009-to-today-recap.png",
      img2Mobile: "assets/images/event-banner/James-webinar-2.png",
      buttonLabel: "View Details",
      buttonLink: "/fca-supervision-2009-to-today",
      buttonLabel2: "Watch Video",
      buttonLink2: "https://youtu.be/0gEWOR7czDA",
    },
    // {
    //   id: 1,
    //   title: "",
    //   img: "assets/images/event-banner/Webnair-02-march.png",
    //   description: "",
    //   img2: "assets/images/event-banner/Webnair-01-march.png",
    //   buttonLabel: "View Details",
    //   buttonLink: "/members-meet-2026",
    //   buttonLabel2: "Register Now",
    //   buttonLink2: "/members-meet-2026#rsvp-form",
    // },
    // {
    //   id: 1,
    //   title: "",
    //   img: "assets/images/event-banner/meetup-main-text-new-april.png",
    //   description: "",
    //   img2: "assets/images/event-banner/meetup-main-subtext-new-april.png",
    //   buttonLabel: "View Details",
    //   buttonLink: "/members-meet-2026",
    //   buttonLabel2: "Register Now",
    //   buttonLink2: "/members-meet-2026#rsvp-form",
    // },
    // {
    //   id: 2,
    //   title: "Stronger Together",
    //   description:
    //     "Together, we can overcome challenges and achieve greater success. Join us to build a supportive community.",
    //   buttonLabel: "Become a Member",
    //   buttonLink: "/become-a-member#membership-form",
    // },
    // {
    //   id: 3,
    //   title: "Join the Association",
    //   description:
    //     "Become a member today! Gain access to resources, networking, and advocacy that empower your business. Let’s drive change together!",
    //   buttonLabel: "Become a Member",
    //   buttonLink: "/become-a-member#membership-form",
    // },
    // {
    //   id: 4,
    //   title: "Not-for-Profit",
    //   description:
    //     "As a Not-for-Profit, the MSB Association is dedicated to supporting your business. Your membership helps strengthen our community.",
    //   buttonLabel: "Become a Member",
    //   buttonLink: "/become-a-member#membership-form",
    // },
    // {
    //   id: 5,
    //   title: "₤1 Per Day",
    //   description:
    //     "Become a member of the MSB Association and together, we can work towards meaningful change while enjoying the benefits of being together!",
    //   buttonLabel: "Become a Member",
    //   buttonLink: "/become-a-member#membership-form",
    // },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
    }, 1000000);
    return () => clearInterval(interval);
  }, [sliderData.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? sliderData.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
  };

  const currentSlide = sliderData[currentIndex];
  const isFirstSlide = currentIndex === 0;

  return (
    <section className="container-fluid banner-custome-padding webinar-hero-ban">
      <style>
        {`
          .webinar-hero-ban .hero_financial_consulting {
            padding: 24px 28px 28px !important;
          }

          .webinar-hero-ban .webinar-hero-row {
            margin: 0 !important;
            align-items: center;
          }

          .webinar-hero-ban .webinar-hero-col {
            padding-left: 12px !important;
            padding-right: 12px !important;
          }

          .webinar-hero-ban .msbimgcss {
            margin-left: 0 !important;
            max-width: 100%;
            width: 100%;
            height: auto;
            display: block;
            padding: 0 !important;
          }

          .webinar-hero-ban .webinar-detail-img {
            max-width: 100%;
            width: 100%;
            height: auto;
            display: block;
            padding: 0 !important;
          }

          .webinar-hero-ban .webinar-detail-crop {
            display: block;
            width: 100%;
            overflow: visible;
            line-height: 0;
          }

          .webinar-hero-ban .btn4 {
            gap: 12px;
            border: 0;
            line-height: 1;
            font-size: 20px;
            overflow: hidden;
            font-weight: 700;
            transition: 300ms;
            position: relative;
            padding: 20px 40px !important;
            align-items: center;
            letter-spacing: -0.2px;
            display: inline-flex;
            justify-content: center;
            color: white !important;
            background-color: #FBA834 !important;
            border-radius: var(--bs-border-radius-pill) !important;
            text-decoration: none;
            z-index: 1;
          }

          .webinar-hero-ban .btn4:before {
            left: 50%;
            bottom: -200%;
            width: 200%;
            height: 200%;
            content: '';
            z-index: -1;
            position: absolute;
            border-radius: 50%;
            transform: translateX(-50%);
            transition: 0.3s ease;
            background-color: #ffffff;
          }

          .webinar-hero-ban .btn4:hover {
            transform: translateY(-2px);
            color: #FBA834 !important;
            box-shadow: 0 21px 12px 0 rgba(1, 58, 55, 0.13);
          }

          .webinar-hero-ban .btn4:hover:before {
            bottom: -70%;
          }

          .webinar-hero-ban .btn-view-details {
            gap: 12px;
            border: 2px solid #FBA834;
            line-height: 1;
            font-size: 20px;
            overflow: hidden;
            font-weight: 700;
            transition: 300ms;
            position: relative;
            padding: 18px 38px !important;
            align-items: center;
            letter-spacing: -0.2px;
            display: inline-flex;
            justify-content: center;
            color: #FBA834 !important;
            background-color: transparent !important;
            border-radius: var(--bs-border-radius-pill) !important;
            text-decoration: none;
            z-index: 1;
          }

          .webinar-hero-ban .btn-view-details:hover {
            background-color: #FBA834 !important;
            color: white !important;
            transform: translateY(-2px);
            box-shadow: 0 21px 12px 0 rgba(1, 58, 55, 0.13);
          }

          @media (min-width: 992px) {
            .webinar-hero-ban .hero_financial_consulting {
              padding: 16px 20px 20px !important;
            }

            .webinar-hero-ban .webinar-hero-col {
              padding-left: 4px !important;
              padding-right: 4px !important;
            }

            .webinar-hero-ban .webinar-hero-col-speaker {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
            }

            .webinar-hero-ban .webinar-hero-col-details {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
            }

            .webinar-hero-ban .webinar-details-copy {
              margin-bottom: 0 !important;
              line-height: 0 !important;
            }

            /* Offsets the transparent space baked into the artwork so the
               image and buttons read as one block centred in the column. */
            .webinar-hero-ban .webinar-detail-img {
              margin-bottom: -4%;
            }

            .webinar-hero-ban .webinar-cta {
              margin-top: 16px !important;
            }
          }

          @media (min-width: 1400px) {
            .webinar-hero-ban .hero_financial_consulting {
              padding: 14px 16px 18px !important;
            }

            .webinar-hero-ban .webinar-hero-inner {
              max-width: 1200px;
              margin: 0 auto;
            }
          }

          @media (min-width: 1600px) {
            .webinar-hero-ban .webinar-hero-inner {
              max-width: 1320px;
            }
          }

          @media (max-width: 991px) {
            .webinar-hero-ban .hero_financial_consulting {
              padding: 12px 10px 14px !important;
              overflow: hidden;
            }

            .webinar-hero-ban .webinar-hero-col {
              padding-left: 4px !important;
              padding-right: 4px !important;
            }

            .webinar-hero-ban .webinar-speaker-img {
              width: 100%;
              max-width: 100%;
              margin: 0 auto 4px;
              display: block;
            }

            /* Crop empty side padding in James-webinar-2 so content fills mobile width */
            .webinar-hero-ban .webinar-detail-crop {
              width: 100%;
              overflow: hidden;
              line-height: 0;
              margin: 12px 0px;
            }

            .webinar-hero-ban .webinar-detail-img {
              width: 132%;
              max-width: none;
              height: auto;
              margin: -2% 0 -1.5% -16%;
              display: block;
            }

            .webinar-hero-ban .webinar-details-copy {
              margin-bottom: 0 !important;
              line-height: 0 !important;
            }

            .webinar-hero-ban .webinar-cta {
              display: flex !important;
              flex-direction: column !important;
              align-items: stretch !important;
              justify-content: center !important;
              gap: 6px !important;
              margin-top: 14px !important;
              padding-left: 0 !important;
            }

            .webinar-hero-ban .btn4,
            .webinar-hero-ban .btn-view-details {
              width: 100%;
              max-width: 100%;
              font-size: 15px;
              padding: 10px 18px !important;
              margin: 0 !important;
            }
          }

          @media (max-width: 575px) {
            .webinar-hero-ban .hero_financial_consulting {
              padding: 10px 8px 12px !important;
            }

            .webinar-hero-ban .webinar-detail-img {
              width: 136%;
              margin: -2.5% 0 -2% -18%;
            }

            .webinar-hero-ban .webinar-cta {
              gap: 5px !important;
              margin-top: 1px !important;
            }

            .webinar-hero-ban .btn4,
            .webinar-hero-ban .btn-view-details {
              font-size: 14px;
              padding: 9px 14px !important;
            }
          }
        `}
      </style>
      <div className="hero_section hero_financial_consulting parallaxie bg-dark position-relative">
        <div className="webinar-hero-inner">
          <div className="row webinar-hero-row align-items-center g-2 g-lg-3">
            {/* Left Side */}
            <div className="col-lg-6 webinar-hero-col webinar-hero-col-speaker">
              <img
                className="msbimgcss webinar-speaker-img"
                src={currentSlide.img}
                alt=""
                style={{
                  display: isFirstSlide ? "block" : "none",
                }}
              />

              <motion.h1
                className="hero_title text-dark mb-0"
                key={currentSlide.id}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                transition={{ duration: 0.5 }}
              >
                {currentSlide.title.split(" ").map((word, i) =>
                  ["Stronger", "Not-for-Profit", "Association", "₤1"].includes(
                    word
                  ) ? (
                    <motion.mark
                      key={i}
                      initial={{ opacity: 0, y: -20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 20 }}
                      transition={{
                        delay: i * 0.2,
                        duration: 0.5,
                        ease: "easeInOut",
                      }}
                      style={{
                        display: "inline-block",
                        background: "#fff",
                        borderRadius: "10px",
                        marginLeft: "10px",
                      }}
                    >
                      {word}
                    </motion.mark>
                  ) : (
                    <span key={i}> {word}</span>
                  )
                )}
              </motion.h1>
            </div>

            {/* Right Side */}
            <div className="col-lg-6 webinar-hero-col webinar-hero-col-details">
              <motion.p
                key={`${currentSlide.id}-desc`}
                className="w-100 webinar-details-copy"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.5 }}
                style={{
                  marginBottom: isFirstSlide ? "" : "",
                }}
              >
                {currentSlide.description}
                {isFirstSlide && currentSlide.img2 && (
                  <span className="webinar-detail-crop d-block">
                    <picture>
                      {currentSlide.img2Mobile && (
                        <source
                          media="(max-width: 991px)"
                          srcSet={currentSlide.img2Mobile}
                        />
                      )}
                      <img
                        src={currentSlide.img2}
                        alt=""
                        className="webinar-detail-img"
                      />
                    </picture>
                  </span>
                )}
              </motion.p>

              {/* Buttons */}
              <div className="d-flex gap-2 flex-wrap sm-justify webinar-cta">
                {currentSlide.buttonLabel && (
                  <NavLink
                    className="btn-view-details"
                    to={currentSlide.buttonLink}
                  >
                    {currentSlide.buttonLabel}
                  </NavLink>
                )}

                {isFirstSlide && currentSlide.buttonLabel2 && (
                  <a
                    href={currentSlide.buttonLink2}
                    className="btn4"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ gap: "10px" }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="#FF0000"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ borderRadius: "4px" }}
                    >
                      <path
                        d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                      />
                    </svg>
                    {currentSlide.buttonLabel2}
                  </a>
                )}
                {/* {isFirstSlide && currentSlide.buttonLabel2 && (
                  <a
                    href={currentSlide.buttonLink2}
                    className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pills btn3"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      background: "#fff",
                      textDecoration: "none",
                      color: "#333",
                      fontWeight: 600,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    <span
                      style={{
                        background: "#FF0000",
                        borderRadius: "25%",
                        width: "35px",
                        height: "28px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M10 16.5L16 12L10 7.5V16.5Z" />
                      </svg>
                    </span>
                    {currentSlide.buttonLabel2}
                  </a>
                )} */}
              </div>
            </div>

            {/* Navigation Arrows */}
            {!isFirstSlide && (
              <div className="w-25 mt-4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    gap: "10px",
                  }}
                >
                  <button
                    className="slider-control left-arrow navigation-btns"
                    onClick={handlePrev}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 19L8 12L15 5"
                        stroke="#333"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <button
                    className="slider-control right-arrow navigation-btns"
                    onClick={handleNext}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 5L16 12L9 19"
                        stroke="#333"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionWebinarBan;
